import { Base } from '@studiometa/js-toolkit';

/**
 * StickyBar
 */
export default class StickyBar extends Base {
  static config = {
    name: 'StickyBar',
  };

  isVisible = false;

  /**
   *
   */
  mounted() {
    this.galleryHeight = document.querySelector('#gallery').offsetHeight - window.innerHeight;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @returns {void}
   */
  scrolled({ y }) {
    if (y <= this.galleryHeight) {
      this.$el.classList.add('translate-y-full');
      this.isVisible = false;
      return;
    }

    if (!this.isVisible && y >= this.galleryHeight) {
      this.isVisible = true;
      this.$el.classList.remove('translate-y-full');
    }
  }
}
